var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQarFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#8D1B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v45h14.85l9.169-2.503-9.169-2.494 9.16-2.503-9.16-2.503 9.16-2.494L14.85 30l9.169-2.503-9.169-2.494 9.16-2.503-9.16-2.503 9.16-2.494L14.85 15l9.169-2.503-9.169-2.494L24.01 7.5l-9.16-2.503 9.169-2.494L14.84 0H0Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQarFlag);
export default __webpack_public_path__ + "static/media/qar-flag.060ef16a42c6c671675aa325e5a41b22.svg";
export { ForwardRef as ReactComponent };